import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { NavService } from '../../service/nav.service';
import { Router } from '@angular/router';
import { AuthenticationService } from '../../../_services/authentication.service';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  public right_sidebar: boolean = false;
  public open: boolean = false;
  public openNav: boolean = false;
  public isOpenMobile : boolean;
  public user : string;

  @Output() rightSidebarEvent = new EventEmitter<boolean>();

  constructor(private http: HttpClient, public navServices: NavService, private router: Router, private authenticationService: AuthenticationService) { }

  collapseSidebar() {
    this.open = !this.open;
    this.navServices.collapseSidebar = !this.navServices.collapseSidebar
  }
  right_side_bar() {
    this.right_sidebar = !this.right_sidebar
    this.rightSidebarEvent.emit(this.right_sidebar)
  }

  openMobileNav() {
    this.openNav = !this.openNav;
  }

  logout() {
    this.authenticationService.logout();
    this.router.navigate(['/login']);
}


  ngOnInit() { 
    if(localStorage.getItem('adminSess') == undefined){
      this.router.navigateByUrl('/auth/login');
    }

    this.http.get<any>(`${environment.apiUrl}/`,  { headers: {'Userinfo': JSON.stringify({_id: localStorage.getItem('adminSess'), role: localStorage.getItem('userRole')})} }).subscribe(
      res => {
        console.log(res)
        if(res.message == 'Logged Out!'){
          localStorage.removeItem('currentUser');
          localStorage.removeItem('userPermission');
          localStorage.removeItem('adminName');
          localStorage.removeItem('userRole');
          localStorage.removeItem('userId');
          localStorage.removeItem('userEmail');
          localStorage.removeItem('adminSess');
          alert();
          this.router.navigate(['/login']);
        }
    },
    (err: HttpErrorResponse) => {
      if (err.error instanceof Error) {
        console.log("Client-side error occured.");
      } else {
        console.log("Server-side error occured.");
      }
    });

    // this.user = localStorage.getItem('adminName').replace(/"/g,'')
    this.user = localStorage.getItem('adminName')
   }

}
